export enum MelFields {
  BuyingGuide = 'buyingGuide',
  Summary = 'summary',
  BottomLine = 'productDescription',
  Faqs = 'faqs',
  Pros = 'pros',
}

export enum AiVariantType {
  Page = 'page',
  Product = 'product',
}

export interface AiVariant {
  id: number;
  entity_id: number;
  type: AiVariantType;
  field_name: string;
  value: string;
  values: object | string[] | string;
  created_at: string;
  selected_at: string;
}

export type AiVariantMap = {
  [x in MelFields]: AiVariant[];
};

export interface AiVariantComment {
  id: number;
  entity_id: number;
  type: AiVariantType;
  field_name: string;
  comment: string;
  created_at: string;
}

export type AiVariantCommentMap = Record<AiVariantComment['field_name'], AiVariantComment[]>;

export interface AiVariantContext {
  context: string | null;
  content: string | null;
  is_new: boolean | null;
  dependency_content: Record<string, string[]> | null;
}
